import React from 'react'
import Head from 'next/head'
import Pitch from '@src/components/DisposalPage/Pitch'
import FeatureList from '@src/components/DisposalPage/FeatureList'
import Approach from '@src/components/DisposalPage/Approach'
import CaseStudy from '@src/components/DisposalPage/CaseStudy'
import FAQ from '@src/components/DisposalPage/FAQ'
import SchemaMarkup from '@src/components/SchemaMarkup'
import RelatedServices from '@src/components/RelatedServices'
import Clients from '@src/pages/LandingPage/Clients'
import Testimonials from '@src/pages/LandingPage/Testimonials'
import junkTestimonials from '@src/constants/junkTestimonials'
import TrustBox from '@src/pages/common/components/TrustBox'
import TrustedByClients from '@src/components/DisposalPage/TrustedByClients'
import pageClasses from '@src/styles/junk-removal-page.module.css'
// eslint-disable-next-line import/extensions
import swaps from '../../json/dumpster-swaps-data.json'

const swapsServiceData = {
  name: 'Dumpster Swap Services',
  description:
    'Nationwide dumpster swaps — a full roll-off container hauled away and an empty one of the same size set in its place during a single visit, booked on call or on a weekly, biweekly, monthly, or quarterly schedule.',
  serviceType: 'Dumpster Swap',
  url: 'https://getdimension.com/dumpster-swaps',
  provider: {
    name: 'Dimension',
    url: 'https://getdimension.com',
    address: {
      streetAddress: '2261 Market Street, #4061',
      addressLocality: 'San Francisco',
      addressRegion: 'CA',
      postalCode: '94114',
      addressCountry: 'US',
    },
    telephone: '+1 (415) 340-7182',
  },
  offers: [
    { name: 'On-Call Dumpster Swap' },
    { name: 'Recurring Dumpster Swap Schedule' },
    { name: 'Unlimited Monthly Dumpster Swaps' },
    { name: 'Cardboard Container Exchange' },
  ],
}

const swapsFAQData = {
  questions: swaps.FAQContent.contentList.map((faq) => ({
    question: faq.heading.replace(/<[^>]*>/g, ''),
    answer: faq.textList.join(' '),
  })),
}

function DumpsterSwaps() {
  return (
    <>
      <Head>
        <title>Dumpster Swaps &amp; Container Exchanges | Dimension</title>
        <meta
          name="description"
          content="Dumpster swaps nationwide: your full container hauled away and an empty one dropped in its place, in one visit. Book on call or on a schedule."
        />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="canonical" href="https://getdimension.com/dumpster-swaps" />
        <SchemaMarkup type="WebSite" />
        <SchemaMarkup type="Service" data={swapsServiceData} />
        <SchemaMarkup type="FAQPage" data={swapsFAQData} />
        <SchemaMarkup type="LocalBusiness" />
      </Head>
      <div className={pageClasses.root}>
        <Pitch
          variant="hazardous-waste"
          heroImage="junk"
          heading={swaps.pitch.heading}
          material={swaps.pitch.material}
          pitchText={swaps.pitch.pitchText}
          ctaLink={swaps.pitch.ctaLink}
          ctaText={swaps.pitch.ctaText}
          ctaHeading={swaps.pitch.ctaHeading}
          ctaSubtext={swaps.pitch.ctaSubtext}
          belowCta={<TrustBox isMobile isDark={false} />}
          belowPitch={<TrustedByClients />}
        />
        <Testimonials testimonials={junkTestimonials} />
        <Clients />
        <FeatureList {...swaps.solutions} />
        <FeatureList {...swaps.benefits} />
        <CaseStudy {...swaps.caseStudy} />
        <Approach {...swaps.approach} />
        <FAQ {...swaps.FAQContent} />
        <RelatedServices
          services={[
            {
              label: 'Dumpster Rental',
              href: '/dumpster-rental',
              description:
                'Container sizes, weight caps, rental periods, and pricing — the detail behind every swap.',
            },
            {
              label: 'Recurring Waste Services',
              href: '/recurring-waste-services',
              description:
                'Put exchanges on a weekly, biweekly, monthly, or quarterly cadence at 15% off.',
            },
            {
              label: 'Cardboard Recycling',
              href: '/cardboard-recycling',
              description:
                'The zero-surcharge stream worth keeping in its own container rather than mixing in.',
            },
            {
              label: 'Pallet Disposal',
              href: '/pallet-disposal',
              description:
                'Wood, plastic, and metal pallets at warehouse volume — the classic 30 yard use case.',
            },
          ]}
        />
      </div>
    </>
  )
}

export default DumpsterSwaps
